import { useRef } from 'react';
import { TableBody, TableRow } from '@pocketlaw/tetris';
import { SearchResultsTableCell } from './SearchResultsTableCell';
import { useTableContext } from './TableContext';
import { canChangeDocumentStatus, isDocument } from './utils';
import { useSearchContext } from '../SearchProvider';
export function SearchResultTableBody() {
    const { values } = useSearchContext();
    const { activeAction, results, selected, setSelected, actions } = useTableContext();
    const { columns } = values;
    const selectedIds = selected.map((item) => item.entityId);
    const isDisabled = (row) => {
        const isSelected = selectedIds.includes(row.entityId);
        if (!activeAction) {
            return false;
        }
        if (activeAction && !isSelected) {
            return true;
        }
        switch (activeAction.name) {
            case 'add-status': {
                return !canChangeDocumentStatus(row);
            }
            case 'move-document':
            case 'plai':
                return !isDocument(row);
            default:
                return true;
        }
    };
    const isRowSelected = (row) => !(activeAction && isDisabled(row)) && selectedIds.includes(row.entityId);
    const onSelectCache = useRef(new WeakMap());
    const getOnSelect = (row) => {
        const cache = onSelectCache.current;
        let handler = cache.get(row);
        if (!handler) {
            handler = () => setSelected({ type: 'toggle', payload: row });
            cache.set(row, handler);
        }
        return handler;
    };
    const visibleColumns = columns.filter((col) => col.active);
    return (<TableBody>
      {results.map((result) => (<TableRow key={result.id} disabled={isDisabled(result)} $selected={isRowSelected(result)}>
          {visibleColumns.map((column) => column.renderComponent ? (column.renderComponent(result)) : (<SearchResultsTableCell key={column.id} column={column} result={result} onSelect={actions ? getOnSelect(result) : undefined} selected={isRowSelected(result)}/>))}
        </TableRow>))}
    </TableBody>);
}
